module.exports = __webpack_public_path__ + "images/klader.a81045db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/klader.jpg
// module id = 6c3cf5d7
// module chunks = 6 16